import { Input, Spinner } from '@platform/components';

type MatchNeedHelpContentProps = {
  additionalDetails: string;
  setAdditionalDetails: (details: string) => void;
  isSaving: boolean;
};
export const MatchNeedHelpContent = (props: MatchNeedHelpContentProps) => {
  const { additionalDetails, setAdditionalDetails, isSaving } = { ...props };

  return (
    <div className='flex flex-col gap-2 items-center md:mt-8 md:w-[500px]'>
      {isSaving ?
        <Spinner />
      : <>
          <div className='text-center text-xl'>
            Let us know what you're struggling with as you make your decision, and a real person
            from our team will follow up with you.
          </div>
          <div className='mt-4'>
            <div className='text-sm'>Additional details</div>
            <Input
              type='multiline'
              placeholder='Enter details'
              onChange={(e) => {
                setAdditionalDetails(e.target.value);
              }}
              value={additionalDetails}
            />
          </div>
        </>
      }
    </div>
  );
};
